import { Button } from '@cokitchen/cokitchen-components';
import LocalModal from '../base/local-modal';
import './styles.scss';
import React from 'react';
import { ReactComponent as DownloadTemplateIcon } from 'assets/icons/download-template.svg';
import { useRef } from 'react';

const XlsInfoModal = ({
  show,
  onClose,
  title,
  handleFileChange,
  handleFileUpload,
  downloadLink,
  children
}: {
  show: boolean;
  onClose: () => void;
  title: string;
  handleFileChange: () => void;
  handleFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  downloadLink: string;
  children: React.ReactNode;
}) => {
  const handleClose = () => {
    onClose();
  };
  const handleDownloadTemplate = () => {
    window.open(downloadLink, '_blank');
  };
  const fileUploadRef = useRef<HTMLInputElement | null>(null);
  const handleConfirm = () => {
    if (fileUploadRef.current) {
      fileUploadRef.current.click();
      handleFileChange();
    }
  };
  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title={title}
      contentClassName='md:!max-w-[400px]'
      footer={
        <div className='flex gap-5 justify-end'>
          <Button
            onClick={handleDownloadTemplate}
            small
            variant='block'
            color='transparent'
            className='text-sm mt-8 '>
            <DownloadTemplateIcon className='mx-1' />
            Download Template
          </Button>

          <Button
            onClick={handleConfirm}
            className='w-[139px] h-[41px] mt-8 text-sm'
            color='primary'
            small
            variant='block'>
            Confirm
          </Button>
          <input
            ref={fileUploadRef}
            type='file'
            accept='.xlsx, .xls'
            hidden
            onChange={handleFileUpload}
          />
        </div>
      }>
      {children}
    </LocalModal>
  );
};

export default XlsInfoModal;
